goog.provide("shadow.js.shim.module$$mui$x_date_pickers$DateField");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers$DateField");
shadow.js.shim.module$$mui$x_date_pickers$DateField = shadow.js.nativeProvides["@mui/x-date-pickers/DateField"] = shadow$bridge("@mui/x-date-pickers/DateField");
module$shadow_js_shim_module$$mui$x_date_pickers$DateField.default = shadow.js.shim.module$$mui$x_date_pickers$DateField;
